(() => {
  if (customElements.get('naked-size-picker')) return;
  class NakedSizePicker extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.links = Array.from(this.querySelectorAll('[data-size-link]'));
      this.maps = new Map(this.links.map(link => [link, JSON.parse(link.dataset.variantMap)]));
      this.updateLinks = () => {
        const purchase = this.closest('.naked-size-purchase');
        const selectedId = purchase?.querySelector('select[name="id"]')?.value || purchase?.querySelector('input[name="id"]')?.value || this.dataset.currentVariant;
        const currentLink = this.querySelector('[aria-current="page"]');
        const selected = this.maps.get(currentLink)?.find(variant => String(variant.id) === selectedId);
        if (!selected) return;
        this.links.forEach(link => {
          const variants = this.maps.get(link);
          const matched = variants.find(variant => variant.title === selected.title && variant.available);
          const destination = matched || variants.find(variant => variant.available) || variants[0];
          if (!destination) return;
          const url = new URL(link.dataset.productUrl, location.origin);
          url.searchParams.set('variant', destination.id);
          link.href = url.pathname + url.search;
        });
      };
      this.addEventListener('click', this.updateLinks, true);
      this.addEventListener('focusin', this.updateLinks);
      this.addEventListener('pointerover', this.updateLinks);
      this.updateLinks();
    }
  }
  customElements.define('naked-size-picker', NakedSizePicker);
})();
